import React, { Component } from 'react';
import { InactivityMonitorConstants } from './InactivityMonitorConstants';
import HeaderLogo from '../../images/headerLogo'
import T from 'i18n-react';

class InactivityMonitorContent extends Component {    
    constructor(props) {
        super(props);

        this.startTime = null;
        this.countdownTimer = null;

        this.state = {          
          started: props.started,
          timeRemaining: ''
        };
        if (props.started) {
            this.startCountdownTimer();            
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.started !== newProps.started){
            this.setState({ started: newProps.started })
            if (newProps.started) {
                this.startCountdownTimer();
            }
        }
    }

    handleLogout = (isAuto) => {
        if (isAuto === true) {
            window.sessionStorage.setItem('spark.logouttype', 'auto')
        }
        this.stopCountdownTimer();

        if (this.props.logoutUser) {
            this.props.logoutUser();
        }
    }

    staySignedIn = () => {
        this.stopCountdownTimer();
        if (this.props.onStaySignedIn) {
            this.props.onStaySignedIn();
        }
    }

    stopCountdownTimer = () => {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
            this.countdownTimer = null
        }
        this.startTime = null;
    }

    startCountdownTimer = () => {
        this.startTime = new Date().getTime();
        this.countdownTimer = setInterval(() => {
            var startTime = this.startTime || new Date().getTime()
            var msRemaining = InactivityMonitorConstants.TIME_TO_SIGNOUT_MINS * 60 * 1000 - (new Date().getTime() - startTime);
            if (msRemaining < 1000) {
                this.handleLogout(true);
            } else {
                var min = Math.floor(msRemaining / (1000 * 60));
                var s = Math.floor((msRemaining / 1000) - min * 60);
                if (s < 10) {
                    s = '0' + s;
                }

                this.setState({ timeRemaining : min > 0 ? ('' + min + ':' + s) : ('0:' + s) })
            }
        }, InactivityMonitorConstants.COUNTDOWN_INTERVAL_MS);
    }   

    render() {
        return (            
            <div className="inactivity-card">
                <div className="inactivity-card-content">
                    <div className="inactivity-card-logo-holder">
                        <HeaderLogo lang={'en'} darkText={true} width={"270px"} />
                    </div>
                    <div className="inactivity-card-content">
                        <p>{T.translate('Inactivity.Subtitle')}</p>
                        <p>{T.translate('Inactivity.Content')}</p>
                        <button onClick={this.staySignedIn} className="button is-link is-fullwidth top-spacing">
                            <span>{T.translate('Inactivity.StayButton', { remainingTime: this.state.timeRemaining })}</span>
                        </button>
                        <button onClick={this.handleLogout} className="button is-link is-fullwidth is-outlined">
                            <span>{T.translate('Inactivity.SignOutButton')}</span>
                        </button>
                    </div>
                </div>
            </div>
        )
    };
}

export default InactivityMonitorContent;